import { render, staticRenderFns } from "./OtherDeclarations.vue?vue&type=template&id=35360382&scoped=true"
import script from "./OtherDeclarations.vue?vue&type=script&lang=js"
export * from "./OtherDeclarations.vue?vue&type=script&lang=js"
import style0 from "./OtherDeclarations.vue?vue&type=style&index=0&id=35360382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35360382",
  null
  
)

export default component.exports